module.exports = __webpack_public_path__ + "assets/images/download-icon.ce4f417c5096b10d6a92f99011c1c9f7.svg";